import React from 'react'
import './AssessmentSection.scss'
import assessmentImage from '../images'

const AssessmentSection = ({ image, text, count }) => {
  return (
    <div className='assessment-section-container'>
      <img className='assessment-section-image' src={image} />
      <div className='detail-container'>
        <div className='section-name'>{text}</div>
        <div className='count-container'>
          <img className='count-image' src={assessmentImage.numberOfItem} />
          <div className='count-text'>{count}</div>
          <div className='count-unit'>ข้อ</div>
        </div>
      </div>
    </div>
  )
}

export default AssessmentSection